export default "__VITE_ASSET__10b7359d__"